import React, { Fragment, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Box, Hide } from 'roo-ui/components';
import { getIsLoading } from 'store/search/searchSelectors';
import MapStateIndicator from 'pages/MapSearch/MapStateIndicator';
import GoogleMap from 'components/maps/GoogleMap';
import FixedSearchControls from 'components/FixedSearchControls';

const FixedPositionWrapper = styled(Box)`
  position: absolute;
  width: 100%;
  bottom: 0;
  height: 0px;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  overflow: visible;
`;

const GoogleMapWithUI = ({ onUpdateQuery, onMapAPILoaded, children, ...props }) => {
  const [mapReady, setMapReady] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const isLoading = useSelector(getIsLoading);

  const handleMapMoved = useCallback(() => {
    if (mapReady) {
      setIsDirty(true);
    }
  }, [mapReady, setIsDirty]);

  const handleRequeryMap = useCallback(() => {
    setIsDirty(false);
    onUpdateQuery();
  }, [setIsDirty, onUpdateQuery]);

  return (
    <Fragment>
      <GoogleMap onMapAPILoaded={onMapAPILoaded} onMapTilesLoaded={setMapReady} onMapMoved={handleMapMoved} ready={mapReady} {...props}>
        {children}
      </GoogleMap>
      {mapReady && (
        <FixedPositionWrapper>
          <MapStateIndicator isMapBoundsDirty={isDirty} isLoading={isLoading} onClick={handleRequeryMap} />
          {!isDirty && (
            <Hide md lg>
              <FixedSearchControls isMapSearch />
            </Hide>
          )}
        </FixedPositionWrapper>
      )}
    </Fragment>
  );
};

GoogleMapWithUI.propTypes = {
  onUpdateQuery: PropTypes.func,
  onMapAPILoaded: PropTypes.func,
  children: PropTypes.node,
};

GoogleMapWithUI.defaultProps = {
  onUpdateQuery: () => {},
  onMapAPILoaded: () => {},
  children: null,
};

export default GoogleMapWithUI;
